/**
 * Home API functions (using Generated SDK)
 * ฟังก์ชัน API สำหรับโฮม (แดชบอร์ด) - ใช้ SDK ที่สร้างอัตโนมัติ
 */

import { Api4 } from '@/services/client'
import type { HomeData } from './types/home.types'

/**
 * Handle SDK error and extract message
 */
function handleError(error: unknown, defaultMessage: string): never {
  if (error && typeof error === 'object' && 'message' in error) {
    throw new Error(String(error.message))
  }
  throw new Error(defaultMessage)
}

/**
 * Get home dashboard data
 * รับข้อมูลแดชบอร์ดหน้าหลัก
 */
export async function getHomeData(): Promise<HomeData> {
  try {
    const { data } = await Api4.getApiDashboard({
      throwOnError: true,
    })
    return data as unknown as HomeData
  } catch (error) {
    handleError(error, 'Failed to fetch dashboard data')
  }
}
